module.exports = __webpack_public_path__ + "static/media/pouring.svg.d56f86e4.png";